export default {
    top_menu: [
        {name:'Pagrindinis dalykas',    id:0},
        {name:'Šou verslas', id:1},
        {name:'Maisto gaminimas',  id:2},
        {name:'Politika',   id:3},
        {name:'+18',  id:4},
        {name:'Visuomenė',   id:5},
        {name:'Sveikata',   id:6},
    ],
    read_other: 'Skaityti daugiau',
    read_more:  'Daugiau informacijos',
    not_found:  'Nieko nerasta',
    read_also:  'Taip pat skaitykite',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Visos programos yra sukurtos.',
    subscribe: 'Prenumeruok',

    thank_order: 'AČIŪ UŽ UŽSAKYMĄ',
    specialist_contact: 'Mūsų specialistas netrukus su jumis susisieks, laukite skambučio.',
    attention: 'Nuolaidos nuo partnerių:',
    hurry: 'Paskubėkite, nuolaidos aktyvinimo laikas yra ribotas! Jūs turite tik <span id="time" class="time">30:00</span> minutes pasirinkti vieną iš šių unikalių produktų:',

    hour_ago1: "Prieš valandą",
    hour_ago2: "prieš valandas",
    hour_ago3: "prieš valandas",
    new_publications: "Nauji leidiniai",
    read: "Skaityti",
    today_at: "Šiandien val",
    author_names: ['Violeta Urmanavičiūtė','Arvydas Sabonis','Jonas Mekas'],
    main_news: "Pagrindinės naujienos",
    leave_already: "Jau išvažiuoji? Palaukite, mes jums atnaujinome naujienas",
    already_shared: "jau pasidalino"

}